import { render, staticRenderFns } from "./PartSoldWarrantyFlag.vue?vue&type=template&id=f1fb0afe&scoped=true"
import script from "./PartSoldWarrantyFlag.vue?vue&type=script&lang=ts"
export * from "./PartSoldWarrantyFlag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb0afe",
  null
  
)

export default component.exports